var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 33.1034,
    r: 18.6207,
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.49991V2.49991H37.5V7.49991H22.5ZM27.5 34.9999H32.5V19.9999H27.5V34.9999ZM30 54.9999C26.9167 54.9999 24.0104 54.4062 21.2813 53.2187C18.5521 52.0312 16.1667 50.4166 14.125 48.3749C12.0833 46.3332 10.4688 43.9478 9.28125 41.2187C8.09375 38.4895 7.5 35.5832 7.5 32.4999C7.5 29.4166 8.09375 26.5103 9.28125 23.7812C10.4688 21.052 12.0833 18.6666 14.125 16.6249C16.1667 14.5832 18.5521 12.9687 21.2813 11.7812C24.0104 10.5937 26.9167 9.99991 30 9.99991C32.5833 9.99991 35.0625 10.4166 37.4375 11.2499C39.8125 12.0832 42.0417 13.2916 44.125 14.8749L47.625 11.3749L51.125 14.8749L47.625 18.3749C49.2083 20.4582 50.4167 22.6874 51.25 25.0624C52.0833 27.4374 52.5 29.9166 52.5 32.4999C52.5 35.5832 51.9062 38.4895 50.7188 41.2187C49.5312 43.9478 47.9167 46.3332 45.875 48.3749C43.8333 50.4166 41.4479 52.0312 38.7188 53.2187C35.9896 54.4062 33.0833 54.9999 30 54.9999ZM30 49.9999C34.8333 49.9999 38.9583 48.2916 42.375 44.8749C45.7917 41.4582 47.5 37.3332 47.5 32.4999C47.5 27.6666 45.7917 23.5416 42.375 20.1249C38.9583 16.7082 34.8333 14.9999 30 14.9999C25.1667 14.9999 21.0417 16.7082 17.625 20.1249C14.2083 23.5416 12.5 27.6666 12.5 32.4999C12.5 37.3332 14.2083 41.4582 17.625 44.8749C21.0417 48.2916 25.1667 49.9999 30 49.9999Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeHover);
export default __webpack_public_path__ + "static/media/real-time-hover.f9eda7ca320ba0e754ed9cadff664f22.svg";
export { ForwardRef as ReactComponent };